import { ref, computed, onMounted } from 'vue';
import { getYearlyData } from '@/services/taxDashboardService';

export function useYearlyData() {
  const yearlyData = ref({});
  const availableYears = ref([]);
  const yearPickerMenu = ref(false);
  const selectedYears = ref([]);

  const sortedSelectedYears = computed(() => [...selectedYears.value].sort());

  const yearPickerDisplay = computed(() => {
    if (selectedYears.value.length === 0) return '';
    const sorted = [...selectedYears.value].sort();
    if (sorted.length <= 3) return sorted.join(', ');
    return `${sorted[0]} - ${sorted[sorted.length - 1]} (${sorted.length} years)`;
  });

  const toggleYear = (year) => {
    const idx = selectedYears.value.indexOf(year);
    if (idx >= 0) {
      selectedYears.value = selectedYears.value.filter((y) => y !== year);
    } else {
      selectedYears.value = [...selectedYears.value, year];
    }
  };

  const clearYears = () => {
    selectedYears.value = [];
  };

  const selectAllYears = () => {
    selectedYears.value = [...availableYears.value];
  };

  const toPieData = (data) => {
    if (!data) return [];
    const total = data.pending + data.completed + data.productRecommendation;
    if (total === 0) return [];
    return [
      { label: 'Pending', value: data.pending, percentage: Math.round((data.pending / total) * 100) },
      { label: 'Completed', value: data.completed, percentage: Math.round((data.completed / total) * 100) },
      { label: 'Product Recommends', value: data.productRecommendation, percentage: Math.round((data.productRecommendation / total) * 100) },
    ];
  };

  const formatNumber = (num) => {
    if (num == null) return '-';
    return num.toLocaleString('en-US');
  };

  const loadData = async () => {
    const data = await getYearlyData();
    yearlyData.value = data;
    const years = Object.keys(data).sort();
    availableYears.value = years;
    if (years.length >= 2) {
      selectedYears.value = [years[years.length - 2], years[years.length - 1]];
    } else if (years.length === 1) {
      selectedYears.value = [years[0]];
    }
  };

  onMounted(() => {
    loadData();
  });

  return {
    yearlyData,
    availableYears,
    yearPickerMenu,
    yearPickerDisplay,
    selectedYears,
    sortedSelectedYears,
    toggleYear,
    clearYears,
    selectAllYears,
    toPieData,
    formatNumber,
    loadData,
  };
}
